/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Channels } from './channels';


export interface UserNotificationSettingResponse { 
    channel: Channels;
    notificationIdentifier: string;
    notificationDescription?: string | null;
    isEnabled: boolean;
}



